import { getComments } from "api/comments/calls";
import { createPaginatedApiQuery } from "hooks/createPaginatedQuery";
import { createApiQuery } from "hooks/createApiQuery";

export const useGetComments = createPaginatedApiQuery(getComments);
export const useGetComment = createApiQuery(getComments);
